<template>
  <div>
    <div style="display: flex; align-items: flex-start">
      <sidebar style="margin-right: 20px; max-width: 200px" />
      <el-card style="width: 100%;">
        <div
          slot="header"
          class="clearfix"
        >
          <span>Üzletláncok</span>
          <el-button
            style="float: right; margin-top: -5px;"
            type="success"
            size="small"
            @click="$router.replace('/data/shops/chains/add')"
            icon="el-icon-plus"
            v-can="'shopchain.create'"
          >
            Új üzletlánc
          </el-button>
        </div>
        <table-filter v-if="config"
          :config="config"
          action="shopChain/fetchAllWithPagination" />
        <list />
        <template v-if="$route.meta.showAddShopChainDialog">
          <shop-chain-dialog
            type="add"
          />
        </template>
        <template v-if="$route.meta.showUpdateShopChainDialog">
          <shop-chain-dialog
            :shopChainId="$route.params.id"
            type="update"
          />
        </template>
      </el-card>
    </div>
  </div>
</template>
<script>
  import Sidebar from '../../../components/data/shops/Sidebar';
  import List from '../../../components/data/shops/chains/List';
  import ShopChainDialog from '../../../components/data/shops/chains/Dialog';
  import TableFilter from '../../../components/TableFilter';

  export default {
    components: {
      Sidebar,
      List,
      ShopChainDialog,
      TableFilter,
    },
    data() {
      return {
        config: null,
      };
    },
    methods: {
      async setConfig() {
        this.config = [
          {
            type: 'text',
            name: 'name',
            label: 'Név',
            defaultSearch: true
          },
        ];
      }
    },
    async mounted() {
      await this.setConfig();
    }
  };
</script>
